<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
      <path d="M10 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v3.5M9 9h1m-1 4h2.5M9 17h1" />
      <path d="M14 21v-4a2 2 0 1 1 4 0v4m-4-2h4m3-4v6" />
    </g>
  </svg>
</template>
